<app-data-grid-comp
    [columns]="columns"
    [bindingType]="bindingType"
    [view]="view"
    [gridData]="gridData"
    [gridDataResult]="gridDataResult"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    [skip]="skip"
    category="Benefits"
    [isLoading]="isLoading"
    (emitPageChangeEvent)="pageChange($event)"
    (emitOpenDialogEvent)="openEmploymentRecordBenefitDialog($event)"
    (emitDeleteEvent)="deleteEmploymentRecordBenefit($event)"
></app-data-grid-comp>